module.exports = __webpack_public_path__ + "static/img/ic_childcenter_on@2x.fec0867.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_childcenter_on@2x.png
// module id = X8bD
// module chunks = 1